import { render, staticRenderFns } from "./ExpoChapterPage.vue?vue&type=template&id=71f3ac2a&scoped=true"
import script from "./ExpoChapterPage.vue?vue&type=script&lang=js"
export * from "./ExpoChapterPage.vue?vue&type=script&lang=js"
import style0 from "./ExpoChapterPage.vue?vue&type=style&index=0&id=71f3ac2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3ac2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f3ac2a')) {
      api.createRecord('71f3ac2a', component.options)
    } else {
      api.reload('71f3ac2a', component.options)
    }
    module.hot.accept("./ExpoChapterPage.vue?vue&type=template&id=71f3ac2a&scoped=true", function () {
      api.rerender('71f3ac2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpoChapterPage.vue"
export default component.exports